export enum GetStartedListPosition {
    ListView,
    QuickOption,
}
